import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logos/safeguard/Logo 150x40.png'
import _imports_1 from '@/assets/banners/safeguard/500X400.png'


const _withScopeId = n => (_pushScopeId("data-v-d45c53a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-dark shadow-sm sticky-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Grupo Safeguard Logo",
  height: "40",
  class: "me-2"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarNav\" aria-controls=\"navbarNav\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" data-v-d45c53a8><span class=\"navbar-toggler-icon\" data-v-d45c53a8></span></button><div class=\"collapse navbar-collapse\" id=\"navbarNav\" data-v-d45c53a8><ul class=\"navbar-nav ms-auto\" data-v-d45c53a8><li class=\"nav-item\" data-v-d45c53a8><a class=\"nav-link\" href=\"#marcas\" data-v-d45c53a8>Nuestras Marcas</a></li><li class=\"nav-item\" data-v-d45c53a8><a class=\"nav-link\" href=\"#nosotros\" data-v-d45c53a8>Sobre Nosotros</a></li><li class=\"nav-item\" data-v-d45c53a8><a class=\"nav-link\" href=\"#contacto\" data-v-d45c53a8>Contacto</a></li></ul></div>", 2)
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", {
    class: "display-4 mb-3",
    style: { fontFamily: 'Myriad Pro Bold, sans-serif' }
  }, "Grupo Safeguard: Soluciones Integrales para Tu Bienestar y Entorno"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "lead mb-4",
    style: { fontFamily: 'Myriad Pro Regular, sans-serif' }
  }, "Innovación y Compromiso en Servicios Esenciales para Hogares y Empresas."),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#marcas",
    class: "btn btn-light btn-lg"
  }, "Explora Nuestras Soluciones")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  id: "marcas",
  class: "py-5"
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "text-center mb-5",
  style: { fontFamily: 'Myriad Pro Bold, sans-serif' }
}, "Descubre Nuestras Marcas Especializadas", -1))
const _hoisted_11 = { class: "row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4" }
const _hoisted_12 = {
  id: "nosotros",
  class: "py-5 bg-light"
}
const _hoisted_13 = { class: "container" }
const _hoisted_14 = { class: "row align-items-center gy-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img-fluid rounded shadow-sm",
    alt: "Grupo Safeguard Team"
  })
], -1))
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<h2 class=\"mb-4\" style=\"font-family:Myriad Pro Bold, sans-serif;font-size:2.25rem;\" data-v-d45c53a8> Sobre Grupo Safeguard </h2><p class=\"lead mb-4\" style=\"font-family:Myriad Pro Regular, sans-serif;font-size:1.125rem;line-height:1.6;\" data-v-d45c53a8><strong data-v-d45c53a8><em data-v-d45c53a8><span style=\"color:#171717;\" data-v-d45c53a8>Grupo Safeguard</span></em></strong><em data-v-d45c53a8><span style=\"color:#171717;\" data-v-d45c53a8> es una empresa consolidada que agrupa diversas unidades de negocio con un enfoque común: brindar servicios de la más alta calidad en la ciudad de Chetumal y sus alrededores, así como en toda la región de Quintana Roo. </span></em><em data-v-d45c53a8><span style=\"color:#171717;\" data-v-d45c53a8>Nuestra cartera de empresas incluye <strong data-v-d45c53a8>Anticovid, Pest Control, Lavandería Premium, Miss Clean y Jardinería Gubernamental</strong>, todas ellas orientadas a satisfacer las necesidades específicas de nuestros clientes, manteniendo un compromiso constante con la excelencia, la innovación y el respeto por el medio ambiente.</span></em></p><div class=\"row g-4\" data-v-d45c53a8><div class=\"col-md-6\" data-v-d45c53a8><div class=\"card h-100 shadow-sm border-0 p-3\" data-v-d45c53a8><div class=\"d-flex align-items-center mb-3\" data-v-d45c53a8><i class=\"bi bi-bullseye fs-2 text-primary me-3\" data-v-d45c53a8></i><h3 class=\"card-title mb-0\" style=\"font-family:Myriad Pro Bold, sans-serif;\" data-v-d45c53a8>Nuestra Misión</h3></div><p class=\"card-text\" style=\"font-family:Myriad Pro Regular, sans-serif;font-size:1rem;line-height:1.5;\" data-v-d45c53a8> Proporcionar soluciones integrales de servicios, que aborden de manera eficiente las necesidades de nuestros clientes, garantizando su bienestar y satisfacción. Nos comprometemos a ofrecer un trabajo de calidad superior, adaptado a las demandas de cada sector, utilizando tecnología avanzada y promoviendo prácticas responsables en todos nuestros procesos. </p></div></div><div class=\"col-md-6\" data-v-d45c53a8><div class=\"card h-100 shadow-sm border-0 p-3\" data-v-d45c53a8><div class=\"d-flex align-items-center mb-3\" data-v-d45c53a8><i class=\"bi bi-eye fs-2 text-primary me-3\" data-v-d45c53a8></i><h3 class=\"card-title mb-0\" style=\"font-family:Myriad Pro Bold, sans-serif;\" data-v-d45c53a8>Nuestra Visión</h3></div><p class=\"card-text\" style=\"font-family:Myriad Pro Regular, sans-serif;font-size:1rem;line-height:1.5;\" data-v-d45c53a8> Ser el grupo empresarial líder en Quintana Roo, reconocido por su capacidad de innovación, su enfoque en el servicio al cliente y su contribución al desarrollo sostenible de la comunidad. Aspiramos a expandir nuestras operaciones y fortalecer nuestra presencia en el mercado, creando un entorno de trabajo que fomente el crecimiento personal y profesional de nuestro equipo. </p></div></div></div>", 3)
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<section id=\"contacto\" class=\"py-5 bg-dark text-white\" data-v-d45c53a8><div class=\"container\" data-v-d45c53a8><h2 class=\"text-center mb-4\" style=\"font-family:Myriad Pro Bold, sans-serif;\" data-v-d45c53a8> Contáctanos </h2><p style=\"font-family:Myriad Pro Regular, sans-serif;\" class=\"text-center mb-4\" data-v-d45c53a8> ¿Tienes alguna pregunta o necesitas una cotización? Estamos aquí para ayudarte. </p><div class=\"row justify-content-center align-items-start\" data-v-d45c53a8><div class=\"col-md-7\" data-v-d45c53a8><form class=\"bg-white text-dark p-4 rounded-4 shadow-sm mb-4 mb-md-0\" data-v-d45c53a8><div class=\"mb-3\" data-v-d45c53a8><label for=\"name\" class=\"form-label\" data-v-d45c53a8>Nombre</label><input type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"Tu nombre completo\" required data-v-d45c53a8></div><div class=\"mb-3\" data-v-d45c53a8><label for=\"email\" class=\"form-label\" data-v-d45c53a8>Correo Electrónico</label><input type=\"email\" class=\"form-control\" id=\"email\" placeholder=\"ejemplo@correo.com\" required data-v-d45c53a8></div><div class=\"mb-4\" data-v-d45c53a8><label for=\"message\" class=\"form-label\" data-v-d45c53a8>Mensaje</label><textarea class=\"form-control\" id=\"message\" rows=\"5\" placeholder=\"Escribe tu mensaje aquí...\" required data-v-d45c53a8></textarea></div><div class=\"d-grid\" data-v-d45c53a8><button type=\"submit\" class=\"btn btn-primary btn-lg\" data-v-d45c53a8>Enviar Mensaje</button></div></form></div><div class=\"col-md-5\" data-v-d45c53a8><div class=\"ps-md-4\" data-v-d45c53a8><p style=\"font-family:Myriad Pro Regular, sans-serif;\" data-v-d45c53a8> Correo: <a href=\"mailto:Gruposafeguard@gmail.com\" class=\"text-white text-decoration-underline\" data-v-d45c53a8> Gruposafeguard@gmail.com </a><br data-v-d45c53a8> Dirección: Chetumal, Quintana Roo </p></div></div></div></div></section>", 1)
const _hoisted_22 = { class: "bg-light text-center text-lg-start py-3" }
const _hoisted_23 = { class: "container text-center" }
const _hoisted_24 = {
  class: "mb-0",
  style: { fontFamily: 'Myriad Pro Regular, sans-serif' }
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: { fontFamily: 'Myriad Pro Regular, sans-serif' }
}, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-decoration-none text-muted"
  }, "Aviso de Privacidad"),
  /*#__PURE__*/_createTextVNode(" | "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "text-decoration-none text-muted"
  }, "Términos y Condiciones")
], -1))

import { ref } from 'vue';
import BrandCard from '@/components/BrandCard.vue';
import heroBanner from '@/assets/banners/safeguard/1920X600.png';
interface Brand {
    name: string;
    slug: string;
    description: string;
    logo?: string;
    color?: string; // Nuevo prop para el color de la tarjeta
}

const primaryColor = 'rgb(204, 12, 42)'; // Rojo principal de Safeguard


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const currentYear = ref(new Date().getFullYear());

const brands: Brand[] = [
    {
        name: 'Lavandería Premium Ecológica',
        slug: 'lavanderia-premium-ecologica',
        description: 'Lavado de ropa y textiles con procesos ecológicos.',
        logo: require('@/assets/productos/safeguard/lavanderia.png'),
        color: 'rgb(16, 84, 128)', // Azul oscuro de Lavandería Premium Ecológica
    },
    {
        name: 'Pest Control Total',
        slug: 'pest-control-total',
        description: 'Control de plagas integral y amigable con el ambiente.',
        logo: require('@/assets/productos/safeguard/pest.png'),
        color: 'rgb(9, 79, 41)', // Verde lima de Pest Control Total
    },
    {
        name: 'Miss Clean',
        slug: 'miss-clean',
        description: 'Servicios de limpieza profunda para hogares y oficinas.',
        logo: require('@/assets/productos/safeguard/mssclean.png'),
        color: 'rgb(221, 120, 144)', // Verde claro de Miss Clean
    },
    {
        name: 'Jardineria Gubernamental',
        slug: 'Jardineria-Gubernamental',
        description: '',
        logo: require('@/assets/productos/safeguard/jardineria.png'),
        color: '#3D432C', // Azul oscuro de Lavandería Premium Ecológica
    },
    {
        name: 'Anticovid',
        slug: 'anticovid',
        description: 'Soluciones profesionales de desinfección y sanitización.',
        logo: require('@/assets/productos/safeguard/anticovid.png'),
        color: '#382968', // Rojo de Anticovid
    },



    {
        name: 'Castelvania',
        slug: 'Castelvania',
        description: 'Eventos Tienda y Camping.',
        logo: require('@/assets/productos/safeguard/castelvania.png'),
        color: '#CB9B48', // Azul oscuro de Lavandería Premium Ecológica
    },
    {
        name: 'ExtinFire',
        slug: 'ExtinFire',
        description: 'Mantenimiento y venta de extintores.',
        logo: require('@/assets/productos/safeguard/extinfire.png'),
        color: '#CE1D43', // Azul oscuro de Lavandería Premium Ecológica
    },

    {
        name: 'Ric-H2O',
        slug: 'Ric-H2O',
        description: '!Vive bien,bebe rico¡',
        logo: require('@/assets/productos/safeguard/rich2o.png'),
        color: '#B4E0E5', // Azul oscuro de Lavandería Premium Ecológica
    },
];



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "navbar-brand",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4
      ])
    ]),
    _createElementVNode("header", {
      class: "text-white text-center py-5 hero-section",
      style: _normalizeStyle({
            backgroundImage: 'url(' + _unref(heroBanner) + ')', 
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            height: '540px'
        })
    }, _hoisted_7, 4),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(brands, (brand) => {
            return _createElementVNode("div", {
              class: "col",
              key: brand.name
            }, [
              _createVNode(BrandCard, {
                brand: brand,
                cardColor: brand.color
              }, null, 8, ["brand", "cardColor"])
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_router_link, {
                to: '/safeguad/about',
                class: "btn btn-primary btn-lg"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Conoce Más ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createTextVNode(" <"),
    _hoisted_21,
    _createElementVNode("footer", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("p", _hoisted_24, "© " + _toDisplayString(currentYear.value) + " Grupo Safeguard. Todos los derechos reservados.", 1),
        _hoisted_25
      ])
    ])
  ]))
}
}

})